import { IntelligentStylesInput } from '@99designs/graph-utils/types';
import {
    MULTI_CHOICE_MUTATION_DEBOUNCE_DURATION,
    MUTATION_DEBOUNCE_MAX_DURATION,
} from '../debounce';
import useDebouncedState from '../useDebouncedState';
import { useUpdateField } from '../useUpdateField';
import { useBriefSetIntelligentStylesMutation } from './IntelligentStyleDesigns.generated';

export function useUpdateIntelligentStylesField(
    key: string,
    briefId?: string,
    initialValue?: IntelligentStylesInput
) {
    const [setDesigns, result] = useBriefSetIntelligentStylesMutation();
    const updateField = useUpdateField<IntelligentStylesInput>({
        key,
        setField: setDesigns,
        briefId,
        initialValue: initialValue || { designs: [], computed: '' },
    });

    const debouncedUpdate = useDebouncedState(
        updateField,
        MULTI_CHOICE_MUTATION_DEBOUNCE_DURATION,
        MUTATION_DEBOUNCE_MAX_DURATION
    );

    return {
        update: debouncedUpdate,
        result,
    };
}
